module.exports = __webpack_public_path__ + "media/images/chat/avatar_placeholder-a4732b502ba1c1b97bf7835e3437c9db.png";